import {
  BMComponentsType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcSystemChevronDown from "@traveloka/icon-kit-web/react/IcSystemChevronDown";
import { useMemo } from "react";
import { Pressable, StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { FacilityItem } from "./types";

type ExtraFacilitiesProps = {
  extraFacilities: FacilityItem[];
  hideExtraFacilities: boolean;
  toggleExtra: () => void;
};

export function ExtraFacilitiesToggle({
  extraFacilities,
  hideExtraFacilities,
  toggleExtra,
}: ExtraFacilitiesProps) {
  const { BMComponents } = useBMTheme();
  const { CorporateMobileFlightPrebook: cr } = useMobileContentResource();
  const styles = useMemo(() => createStyles(BMComponents), [BMComponents]);

  return (
    <BMView style={styles.extra} row align="center" justify="end">
      {hideExtraFacilities && (
        <BMView flex row spacing="sm">
          {extraFacilities.map((item, index) => {
            const icon = item.getIcon(12);
            return <BMView key={`extra-facility-lite-${index}`}>{icon}</BMView>;
          })}
        </BMView>
      )}
      <Pressable onPress={toggleExtra} accessibilityRole="button">
        <BMView row spacing="xs" align="center">
          <BMText variant="uiNormalLi" ink="BMStyleTextInkAction">
            {hideExtraFacilities ? cr.moreItem : cr.lessItem}
          </BMText>
          <BMView
            style={{
              transform: [{ rotate: hideExtraFacilities ? "0deg" : "-180deg" }],
            }}
          >
            <IcSystemChevronDown
              width={16}
              height={16}
              color={BMComponents.BMStyleTextInkAction}
            />
          </BMView>
        </BMView>
      </Pressable>
    </BMView>
  );
}

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    container: {
      borderRadius: BMPrimitives.BMRadius.md,
      borderWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
      backgroundColor: BMComponents.BMStyleSurfaceBgcolorInventory,
    },
    content: {
      padding: BMPrimitives.BMSize.md,
    },
    divider: {
      borderTopWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
    },
    extra: {
      backgroundColor: BMComponents.BMStyleSurfaceBgcolor,
      borderTopWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
      paddingVertical: BMPrimitives.BMSize.sm,
      paddingHorizontal: BMPrimitives.BMSize.md,
      borderEndEndRadius: BMPrimitives.BMRadius.md,
      borderEndStartRadius: BMPrimitives.BMRadius.md,
    },
  });
}
